import { render, staticRenderFns } from "./GalleryStandard.vue?vue&type=template&id=e1bd9f52&scoped=true&"
import script from "./GalleryStandard.vue?vue&type=script&lang=js&"
export * from "./GalleryStandard.vue?vue&type=script&lang=js&"
import style0 from "./GalleryStandard.vue?vue&type=style&index=0&id=e1bd9f52&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bd9f52",
  null
  
)

export default component.exports